module.exports = __webpack_public_path__ + "assets/images/sizeofOffice-04.b288937308cbca914bdb03c82b63ad3e.svg";